<template>
  <div class="map-page">
    <div class="map-hero">
      <div class="gs-hero-art" aria-hidden="true"></div>
      <div class="map-hero-inner">
        <div>
          <h1>{{ name }}数据产业地图</h1>
          <p>{{ currentLevel === 'city' ? '当前为城市视图，可返回本省或全国。' : '查看本省数据服务商与产品。点击地市可继续下钻。' }}</p>
        </div>
        <div class="hero-actions">
          <button v-if="currentLevel === 'city'" type="button" class="map-back" @click="backProvince">返回本省</button>
          <button type="button" class="map-back" @click="goNational">返回全国</button>
        </div>
      </div>
      <div class="map-metrics three">
        <div class="metric">
          <div class="metric-num"><em>{{ counts.serviceProviderCount || 0 }}</em>家</div>
          <div class="metric-label">数据服务商</div>
        </div>
        <div class="metric">
          <div class="metric-num"><em>{{ counts.productCount || 0 }}</em>条</div>
          <div class="metric-label">数据产品</div>
        </div>
        <div class="metric">
          <div class="metric-num"><em>{{ counts.expertCount || 0 }}</em>人</div>
          <div class="metric-label">专家资源库</div>
        </div>
      </div>
    </div>

    <div class="map-body">
      <div class="prov-layout">
        <section class="side-col">
          <header>
            <strong>数据服务商</strong>
            <span>{{ providerTotal }}</span>
          </header>
          <div class="side-head"><span>名称</span><span>场景</span></div>
          <div class="side-list">
            <button
              v-for="(row, index) in pagedProviders"
              :key="(row.enterpriseId || row.dataName) + '-' + index"
              type="button"
              class="side-row"
              @click="openEnterprise(row)"
            >
              <span :title="row.dataName">{{ row.dataName || '-' }}</span>
              <span>{{ row.dataApplicationScenarios || '-' }}</span>
            </button>
            <div v-if="!providerTotal" class="side-empty">暂无入驻服务商</div>
          </div>
          <div class="table-pagination">
            <GsPagination
              :current-page="providerPage"
              :page-size="sidePageSize"
              :total="providerTotal"
              @current-change="handleProviderPage"
            />
          </div>
        </section>

        <section class="map-col">
          <div class="map-head">
            <strong>{{ name }}</strong>
            <span>点击地市查看下级分布</span>
          </div>
          <div class="mapChina" id="mapChina" ref="china" />
        </section>

        <section class="side-col">
          <header>
            <strong>数据产品</strong>
            <span>{{ productTotal }}</span>
          </header>
          <div class="side-head"><span>产品信息</span><span>类型</span></div>
          <div class="side-list">
            <button
              v-for="(row, index) in pagedProducts"
              :key="(row.enterpriseId || row.dataProductInfo) + '-' + index"
              type="button"
              class="side-row"
              @click="openEnterprise(row)"
            >
              <span :title="row.dataProductInfo">{{ row.dataProductInfo || '-' }}</span>
              <span :class="row.type === 1 ? 'tag-buy' : (row.type === 3 ? 'tag-other' : 'tag-sell')">
                {{ row.typeName || '-' }}
              </span>
            </button>
            <div v-if="!productTotal" class="side-empty">暂无公开产品</div>
          </div>
          <div class="table-pagination">
            <GsPagination
              :current-page="productPage"
              :page-size="sidePageSize"
              :total="productTotal"
              @current-change="handleProductPage"
            />
          </div>
        </section>
      </div>

      <div class="industry-wrap">
        <IndustryInfo />
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { getTwoMapPlatform } from '@/api/components/index.js'
import requset from '@/utils/request.js'
import { cityMap } from '@/views/mapComponent/mapData/citys/china-main-city-map.js'
import IndustryInfo from '../../components/IndustryInfo'
import GsPagination from '@/components/GsPagination/index.vue'
import mapPro from './mapJson'
import { applyBestChinaLayout, syncMapContainer, mapTooltipOption, mapPaint, mapVisualRange } from '@/utils/mapTooltip'
import { P, routeName } from '@/router/paths'
export default {
  name: 'ProviderMapIndex',
  components: { IndustryInfo, GsPagination },
  data() {
    const region = routeName(this.$route) || this.$route.params.name
    return {
      name: region,
      provinceName: region,
      title: this.$route.meta.title,
      dataForm: {
        getServiceProviderList: [],
        getDataProductListModelList: [],
        getTwoMapPlatformCountModel: {}
      },
      getMapRegionNumPlatformOutputList: [],
      mapMetricCards: [],
      currentRegionId: null,
      getMapStatisticsPlatformOutput: {},
      currentLevel: 'province',
      providerPage: 1,
      productPage: 1,
      sidePageSize: 8,
      levelConfig: {
        china: { nextLevel: 'province', geoKey: 'china', jsonPath: 'province' },
        province: { nextLevel: 'city', geoKey: 'province', jsonPath: 'city' },
        city: { nextLevel: 'county', geoKey: 'city', jsonPath: 'county' }
      },
      chart: null
    }
  },
  computed: {
    providerList() {
      return this.dataForm.getServiceProviderList || []
    },
    productList() {
      const list = this.dataForm.getDataProductListModelList || []
      return list.map((row) => ({
        ...row,
        typeName: row.typeName || (row.type === 1 ? '需求' : row.type === 3 ? '其他' : '供应')
      }))
    },
    providerTotal() {
      return this.providerList.length
    },
    productTotal() {
      return this.productList.length
    },
    pagedProviders() {
      return this.pageOf(this.providerList, this.providerPage)
    },
    pagedProducts() {
      return this.pageOf(this.productList, this.productPage)
    },
    counts() {
      const c = this.dataForm.getTwoMapPlatformCountModel || {}
      const cards = this.mapMetricCards || []
      const find = (key) => {
        const hit = cards.find((x) => x.key === key)
        return hit ? hit.value : 0
      }
      return {
        serviceProviderCount: c.serviceProviderCount || find('dataServiceProvider') || 0,
        productCount: c.productCount || find('datasetCount') || 0,
        expertCount: c.expertCount || find('expertCount') || 0
      }
    }
  },
  watch: {
    '$route.params.name'() {
      const region = routeName(this.$route) || this.$route.params.name
      this.name = region
      this.provinceName = region
      this.currentLevel = 'province'
      this.providerPage = 1
      this.productPage = 1
      this.initMap()
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    window.addEventListener('resize', this.onMapResize)
    this.$nextTick(() => this.bindMapObserver())
  },
  beforeUnmount() {
    this.teardownMap()
  },
  beforeDestroy() {
    this.teardownMap()
  },
  created() {
    this.initMap()
  },
  methods:{
    mapMode() {
      return window.innerWidth < 960 ? 'mobile' : 'province-desktop'
    },
    unwrapGeo(mapCode) {
      return mapCode && mapCode.default ? mapCode.default : mapCode
    },
    bindMapObserver() {
      const el = this.$refs.china
      if (!el || typeof ResizeObserver === 'undefined') return
      if (this._mapObs) this._mapObs.disconnect()
      this._mapObs = new ResizeObserver(() => {
        if (this._mapRoTick) return
        this._mapRoTick = true
        requestAnimationFrame(() => {
          this._mapRoTick = false
          this.onMapResize()
        })
      })
      this._mapObs.observe(el)
    },
    onMapResize() {
      clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => this.fitMap(), 120)
    },
    fitMap() {
      const el = this.$refs.china
      if (!el || !this.chart || this.chart.isDisposed()) return
      const mode = this.mapMode()
      syncMapContainer(el, mode === 'mobile')
      const w = el.clientWidth
      const h = el.clientHeight
      if (!w || !h) return
      if (w === this._lastMapW && h === this._lastMapH && mode === this._lastMapMode) return
      this._lastMapW = w
      this._lastMapH = h
      this._lastMapMode = mode
      const layout = {}
      applyBestChinaLayout(layout, mode)
      try { this.chart.setOption({ series: [layout] }) } catch (e) {}
      try { this.chart.resize({ width: w, height: h }) } catch (e) {}
    },
    teardownMap() {
      window.removeEventListener('resize', this.onMapResize)
      if (this._mapObs) {
        this._mapObs.disconnect()
        this._mapObs = null
      }
      if (this.chart && !this.chart.isDisposed()) {
        try {
          this.chart.off('click')
          this.chart.dispose()
        } catch (e) {}
      }
      this.chart = null
    },
    pageOf(list, page) {
      const size = this.sidePageSize || 8
      const rows = list || []
      const maxPage = Math.max(1, Math.ceil(rows.length / size) || 1)
      const current = Math.min(Math.max(1, page || 1), maxPage)
      const start = (current - 1) * size
      return rows.slice(start, start + size)
    },
    handleProviderPage(page) {
      this.providerPage = page
    },
    handleProductPage(page) {
      this.productPage = page
    },
    openEnterprise(row) {
      const id = row && (row.enterpriseId || row.companyId)
      if (!id) return
      this.$router.push(P.enterprise(id))
    },
    goNational() {
      this.$router.push(P.map)
    },
    backProvince() {
      const name = this.provinceName || routeName(this.$route) || this.name
      this.currentLevel = 'province'
      this.name = name
      const mapCode = (mapPro.provinceByName || {})[name]
      this.initDataMap(name, mapCode)
    },
    pickTwoMapPayload(raw) {
      const d = (raw && (raw.data || raw)) || {}
      return {
        getServiceProviderList: d.getServiceProviderList || [],
        getDataProductListModelList: d.getDataProductListModelList || [],
        getTwoMapPlatformCountModel: d.getTwoMapPlatformCountModel || {}
      }
    },
    initDataMap(data, mapCode) {
      this.$nextTick(() => this.getMap(data, mapCode, this.getMapRegionNumPlatformOutputList))
      const hit = (this.getMapRegionNumPlatformOutputList || []).find((r) => r.name === data)
      const currentId = hit && hit.regionId ? hit.regionId : this.currentRegionId
      const url = currentId ? `/xwzx/map/statistics?regionId=${currentId}` : '/xwzx/map/statistics'
      requset({ url, method: 'GET' }).then((res) => {
        const payload = (res && res.data) || {}
        this.mapMetricCards = payload.metrics || []
        this.currentRegionId = payload.regionId || currentId || null
        this.getMapRegionNumPlatformOutputList = (payload.rows || []).map((row) => ({
          name: row.name,
          regionId: row.regionId,
          level: row.level,
          canDrill: row.canDrill,
          dataServiceProvidersNum: row.dataServiceProvider,
          dataExchange: row.dataExchange,
          expertCount: row.expertCount,
          dataInformationQuantity: row.newsCount,
          dataSetCount: row.datasetCount,
          listingCount: row.listingCount,
          bookCount: row.bookCount,
          heat: row.heat
        }))
        this.$nextTick(() => this.getMap(data, mapCode, this.getMapRegionNumPlatformOutputList))
      }).catch(() => {})
      getTwoMapPlatform(data).then((resData) => {
        this.providerPage = 1
        this.productPage = 1
        this.dataForm = this.pickTwoMapPayload(resData)
      }).catch(() => {})
    },
    initMap() {
      const name = this.name || routeName(this.$route)
      const provinces = mapPro.provinceByName || {}
      this._mapProvinces = provinces
      if (this.currentLevel === 'province' || !this.currentLevel) {
        this.currentLevel = 'province'
        this.provinceName = this.provinceName || name
        this.initDataMap(name, provinces[name])
      }
    },
    bindMapClick() {
      if (!this.chart || this.chart.isDisposed()) return
      const _this = this
      this.chart.off('click')
      this.chart.on('click', async function(params) {
        if (!params || !params.name) return
        const name = params.name
        const currentConfig = _this.levelConfig[_this.currentLevel]
        if (!currentConfig) return
        if (currentConfig.nextLevel === 'city') {
          try {
            const adcode = cityMap[name]
            if (!adcode) return
            _this.currentLevel = 'city'
            _this.name = name
            const newGeoJsonCity = await import(`@/views/mapComponent/mapData/citys/${adcode}.json`)
            _this.initDataMap(name, newGeoJsonCity)
          } catch (error) {
            _this.currentLevel = 'province'
            _this.name = _this.provinceName
          }
        }
      })
    },
    getMap(mapName, mapCode, allData) {
      const el = this.$refs.china
      const geo = this.unwrapGeo(mapCode)
      if (!el || !geo) return
      echarts.registerMap(mapName, geo)
      const mobile = window.innerWidth < 960
      syncMapContainer(el, mobile)
      const myChart = (this.chart && !this.chart.isDisposed()) ? this.chart : (echarts.getInstanceByDom(el) || echarts.init(el))
      this.chart = myChart
      const fontSize = mobile ? '10px' : '12px'
      const list = (allData || []).map((d) => ({
        ...d,
        name: d.name || d.regionName,
        value: Number(d.dataServiceProvidersNum || d.value || 0)
      }))
      const seriesItem = mapPaint({
        name: 'MAP',
        type: 'map',
        map: mapName,
        mapType: mapName,
        aspectScale: 0.75,
        showLegendSymbol: false,
        zoom: 1,
        roam: false,
        label: {
          show: !mobile,
          fontSize: fontSize,
          color: '#16325c'
        },
        data: list
      })
      applyBestChinaLayout(seriesItem, this.mapMode())
      myChart.setOption({
        tooltip: mapTooltipOption(),
        visualMap: {
          type: 'continuous',
          min: 0,
          max: mapVisualRange(list),
          left: mobile ? 8 : 12,
          bottom: mobile ? 8 : 12,
          itemWidth: 10,
          itemHeight: mobile ? 48 : 72,
          text: ['多', '少'],
          textStyle: { color: '#5B6B82', fontSize: 11 },
          inRange: { color: ['#E7F0FF', '#8FBAFF', '#0165FF'] },
          hoverLink: false
        },
        series: [seriesItem]
      }, true)
      this.bindMapClick()
      this._lastMapW = 0
      this.$nextTick(() => this.fitMap())
    }
  }
}
</script>
<style scoped>
.map-page {
  width: 100%;
  padding-bottom: 28px;
  overflow: visible;
  color: #1d2b44;
  position: relative;
}
.map-page::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  z-index: 0;
  pointer-events: none;
  background-color: #D7E7F8;
  background-image: url('@/assets/images/编组 65@2x.png');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
}
.map-hero,
.map-body {
  position: relative;
  z-index: 1;
}
.map-hero {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  overflow: hidden;
  background: #0165FF;
}
.map-hero :deep(.gs-hero-art) {
  background-position: center;
}
.map-hero-inner,
.map-metrics {
  position: relative;
  z-index: 1;
  width: min(var(--gs-main-width, 1250px), calc(100% - 32px));
  margin: 0 auto;
}
.map-hero-inner {
  padding: 22px 0 16px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.map-hero h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1.15;
  font-weight: 800;
  color: #fff;
}
.map-hero p {
  margin: 8px 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.88);
}
.hero-actions {
  display: flex;
  gap: 16px;
  flex: 0 0 auto;
}
.map-back {
  padding: 0;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.85);
  background: none;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
}
.map-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-bottom: 22px;
}
.metric {
  padding: 0 24px;
  border-left: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
}
.metric:first-child {
  padding-left: 0;
  border-left: 0;
}
.metric-num {
  font-size: 13px;
  opacity: 0.9;
}
.metric-num em {
  font-style: normal;
  font-size: 28px;
  font-weight: 800;
  margin-right: 4px;
  letter-spacing: -0.5px;
}
.metric-label {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.82;
}
.map-body {
  width: 100%;
}
.prov-layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr) 240px;
  gap: 0 28px;
  align-items: stretch;
  padding-top: 8px;
}
.side-col {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}
.side-col header,
.map-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0 8px;
  border-bottom: 1px solid #E6EAF0;
}
.side-col header strong,
.map-head strong {
  font-size: 16px;
  font-weight: 700;
}
.side-col header span {
  font-size: 12px;
  color: #0165FF;
}
.map-head span {
  font-size: 13px;
  color: #7b889c;
}
.side-head,
.side-row {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 8px;
  align-items: center;
  width: 100%;
}
.side-head {
  color: #7b889c;
  font-size: 12px;
  padding: 10px 0 6px;
}
.side-list {
  flex: 1;
  overflow: auto;
  max-height: 420px;
}
.table-pagination {
  margin-top: 8px;
}
.table-pagination :deep(.gs-pager) {
  margin: 8px 0 0;
  gap: 6px;
  justify-content: flex-start;
}
.side-row {
  appearance: none;
  border: 0;
  border-bottom: 1px solid #EEF1F5;
  background: transparent;
  min-height: 42px;
  padding: 0;
  color: #334155;
  text-align: left;
  cursor: pointer;
}
.side-row span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.side-row:hover {
  color: #0165FF;
}
.side-empty {
  padding: 28px 0;
  color: #94a3b8;
  font-size: 13px;
}
.tag-buy { color: #D9001B; font-weight: 600; }
.tag-sell { color: #0165FF; font-weight: 600; }
.tag-other { color: #5b6b82; }
.map-col {
  min-width: 0;
  border-left: 1px solid #E6EAF0;
  border-right: 1px solid #E6EAF0;
  padding: 0 20px;
}
.mapChina {
  height: 680px;
  width: 100%;
}
.industry-wrap {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #E6EAF0;
}
@media (max-width: 1249px) {
  .map-body {
    width: min(var(--gs-main-width, 1250px), calc(100% - 32px));
    margin: 0 auto;
  }
  .prov-layout {
    grid-template-columns: 200px minmax(0, 1fr) 200px;
    gap: 0 16px;
  }
  .map-col { padding: 0 12px; }
}
@media (max-width: 960px) {
  .map-hero-inner,
  .map-metrics {
    width: calc(100% - 24px);
  }
  .map-hero-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .map-hero h1 { font-size: 22px; }
  .map-metrics { grid-template-columns: 1fr; row-gap: 12px; }
  .metric,
  .metric:first-child {
    padding: 10px 0 0;
    border-left: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.28);
  }
  .metric:first-child { border-top: 0; padding-top: 0; }
  .metric-num em { font-size: 22px; }
  .prov-layout { grid-template-columns: 1fr; }
  .map-col {
    border-left: 0;
    border-right: 0;
    padding: 0;
    border-top: 1px solid #E6EAF0;
    border-bottom: 1px solid #E6EAF0;
  }
  .mapChina {
    height: 86vw;
    min-height: 260px;
    max-height: 380px;
  }
  .side-list { max-height: 280px; }
  .map-head { flex-direction: column; gap: 4px; }
}
</style>
